export type CreatePodcastSupporterParams = {
  email: string;
  methodName?: string;
  name: string;
  productId: string;
  referringPlatform?: string;
  token?: any; // stripe object
  stationId: string;
};

export async function createPodcastSupporter({
  email,
  methodName,
  name,
  productId,
  referringPlatform,
  token,
  stationId,
}: CreatePodcastSupporterParams) {
  try {
    const resp = await fetch(`/api/station/${stationId}/support`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify({
        email,
        methodName,
        name,
        productId,
        stationId,
        referringPlatform,
        token,
      }),
    });

    if (resp.ok) {
      return resp.json();
    }

    if (resp.status === 400) {
      throw new Error('Card error');
    }

    throw new Error('Unable to create supporter');
  } catch (e) {
    throw new Error(e.message);
  }
}
